import { DateUtils, Product } from '@eo-storefronts/eo-core'
import { useEffect, useState } from 'react'
import { useProductAvailableState } from '~/src/hooks/products/useProductAvailableState'
import { useEoValue } from '~/src/hooks/useEoState'
import { useTranslations } from '~/src/hooks/useTranslations'
import { CHECKOUT_FORM_STATE } from '~/src/stores/checkout'
import { LANGUAGE_STATE } from '~/src/stores/lang'

interface ReturnsType {
  nextAvailability: string,
}

const useProductAvailabilityMessage = (product: Product): ReturnsType => {
  const lang = useEoValue(LANGUAGE_STATE)
  const { t } = useTranslations()
  const checkoutForm = useEoValue(CHECKOUT_FORM_STATE)
  const { state: productAvailableState } = useProductAvailableState(product)
  const [ nextAvailability, setNextAvailability ] = useState<string>('')

  useEffect(() => {
    if (productAvailableState.inStock && !productAvailableState.snoozed) {
      setNextAvailability('')
      return
    }

    if (!productAvailableState.inStock) {
      setNextAvailability(t('product.out_of_stock'))
      return
    }

    const deliveryDate = checkoutForm.delivery_method.time ? new Date(checkoutForm.delivery_method.time) : new Date()

    setNextAvailability(`${t('product.unavailable')} ${DateUtils.calendarSentence(deliveryDate, new Date(product.snooze!.end!))}`)
  }, [ productAvailableState, lang ])

  return { nextAvailability }
}

export {
  useProductAvailabilityMessage
}
